import React from 'react';

import {
  NewRecognitionExperience,
  NewRecognitionGifts,
  NewRecognitionRecipients,
  NewRecognitionReviewAndPay,
  RecognitionThankYouNoteDetail,
  NewRecognitionShare,
  OrderConfirmed,
  NewRecognitionContactType
} from '@hero/pages';

import { paths } from '../paths';

const newRecognitionRoutes = [
  {
    path: paths.NEW_RECOGNITION_GIFTS,
    middlewares: [{ key: 'page-status', provider: 'ValidationErrorsProvider' }],
    element: <NewRecognitionGifts />,
    state: {
      pageKey: 'NewRecognition',
      metadata: {
        title: 'New recognition gifts'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.NEW_RECOGNITION_RECIPIENTS,
    middlewares: [{ key: 'page-status', provider: 'ValidationErrorsProvider' }],
    element: <NewRecognitionRecipients />,
    state: {
      pageKey: 'NewRecognition',
      metadata: {
        title: 'New recognition recipients'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.NEW_RECOGNITION_CONTACT_TYPE,
    middlewares: [{ key: 'page-status', provider: 'ValidationErrorsProvider' }],
    element: <NewRecognitionContactType />,
    state: {
      pageKey: 'NewRecognition',
      metadata: {
        title: 'New recognition sharing'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.NEW_RECOGNITION_EXPERIENCE,
    middlewares: [{ key: 'page-status', provider: 'ValidationErrorsProvider' }],
    element: <NewRecognitionExperience />,
    state: {
      pageKey: 'NewRecognition',
      metadata: {
        title: 'New recognition experience'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.NEW_RECOGNITION_REVIEW_PAY(),
    middlewares: [{ key: 'page-status', provider: 'ValidationErrorsProvider' }],
    element: <NewRecognitionReviewAndPay />,
    state: {
      pageKey: 'NewRecognition',
      metadata: {
        title: 'Review & Pay'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.NEW_RECOGNITION_SHARE(),
    element: <NewRecognitionShare />,
    state: {
      pageKey: 'NewRecognition',
      metadata: {
        title: 'Share'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.RECOGNITION_THANK_YOU_NOTES,
    element: <RecognitionThankYouNoteDetail />,
    state: {
      pageKey: 'Recognition',
      metadata: {
        title: 'Share'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.NEW_RECOGNITION_ORDER_CONFIRMED(),
    element: <OrderConfirmed />,
    state: {
      pageKey: 'Recognition',
      metadata: {
        title: 'Order Confirmed'
      },
      shoppingCart: {
        enabled: false
      }
    }
  }
];

export { newRecognitionRoutes };
